import { createFileRoute } from "@tanstack/react-router";
import AdminPartsTaxRates from "@/pages/admin/AdminPartsTaxRates";

export const Route = createFileRoute("/_adminLayout/admin/parts/tax-rates")({
  component: AdminPartsTaxRates,
});
